import AllBrandsView from "./AllBrandsView";

export default AllBrandsView;